export const iconFontAwesomeEditingCircleHalfStroke = (
	<i className="fa-solid fa-circle-half-stroke"></i>
);
